<template>
  <div class="staffhistoryDetail">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div
      class="visitStatusBox"
      :style="`background-color: ${color}`"
    >{{ headName }}</div>
    <div class="content">
      <p class="content-title">卡券信息</p>
      <van-cell title="卡券名称">
        <template #right-icon>
          {{ historyDetail.couponName }}
        </template>
      </van-cell>
      <van-cell title="卡券面额">
        <template #right-icon>
          {{ historyDetail.deductionTimes || historyDetail.deductionFee }}{{ historyDetail.consumeType === 'COST_PER_TIMES' ? '次' : '元' }}
        </template>
      </van-cell>
    </div>
    <div class="content">
      <p class="content-title">申请信息</p>
      <van-cell title="申请人">
        <template #right-icon>
          {{ historyDetail.applicant }}
        </template>
      </van-cell>
      <van-cell title="领取人">
        <template #right-icon>
          {{ historyDetail.receiptor }}
        </template>
      </van-cell>
      <van-cell title="申请数量（张）">
        <template #right-icon>
          {{ historyDetail.applyCount }}
        </template>
      </van-cell>
      <div class="itemClass">
        <div class="meetingItem">
          <div>申请理由</div>
          <div style="word-break: break-all; word-wrap: break-word;">{{ historyDetail.applyReason || '无' }}</div>
        </div>
      </div>
      <div v-if="historyDetail.attachmentUrls && historyDetail.attachmentUrls.length > 0" class="content">
        <p class="content-title">附件
        </p>
        <van-cell-group>
          <van-cell v-for="(item, index) in historyDetail.attachmentUrls" :key="index">
            <template #title>
              <div class="uploadList" @click="() => showImg(index)">
                <img class="thumbnail" :src="baseURL + item" alt="">
                <span class="nameArea">
              <span class="imgName">附件{{ index + 1 }}</span>
            </span>
              </div>
            </template>
            <template #right-icon>
              <van-icon name="eye-o" color="#3b86ff" class="tag" @click="() => showImg(index)" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="content">
        <p class="content-title">申请动态</p>
        <van-steps direction="vertical" :active="historyDetail.logs && historyDetail.logs.length - 1">
          <van-step v-for="son in historyDetail.logs">
            <div>{{ son.remark }}</div>
            <p>{{ son.createTime }}</p>
          </van-step>
        </van-steps>
      </div>
    </div>
    <div v-if="fromName === 'review' && historyDetail.auditStatus === 'AUDIT_WAITTING'" class="btns">
      <div style="margin-right: 0.1rem" @click="refuseCheck">拒绝</div>
      <div @click="passCheck">通过</div>
    </div>
    <van-dialog v-model="showRefuseDialog" title="温馨提示" show-cancel-button @confirm="confirmRefuse">
      <van-cell-group>
        <van-field v-model="message" class="control" rows="1" autosize type="textarea" placeholder="请输入拒绝原因" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import {
  applyCouponInfo,
  consumeAuditInfo,
  auditCoupon
} from '@/api/user';
import Clipboard from 'clipboard';
import { ImagePreview, Step, Steps } from 'vant'
import config from '@/common/config';
export default {
  name: 'VoucherInfo',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  data() {
    return {
      fromName: this.$route.query.from,
      subHead: '详情',
      headName: '',
      color: '',
      personalInfo: {},
      showRefuseDialog: false,
      showTips: false,
      showShareBtn: false,
      showCancelDialog: false,
      showMeetingCancelDialog: false,
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      message: '',
      meetingMessageCancel: '',
      messageCancel: '',
      historyDetail: {
        attachmentUrls: [],
        logs: []
      },
      acpyVisitorsArr: [
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '',
          status: 'CANCEL'
        },
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '粤AC527',
          status: 'WAITING_VISIT'
        },
        {
          name: '张大大',
          phone: '13507245734',
          status: 'FINISH',
          carNumber: ''

        }
      ],
      statusMap: {
        AUDIT_CANCEL: ['取消审核', '#919191'],
        AUDIT_WAITTING: ['待审核', '#F76260'],
        AUDIT_OUTTIME: ['超时未审核', '#F2B230'],
        AUDIT_REJECT: ['未过审', '#919191'],
        AUDIT_PASS: ['审核通过', '#2DCC2C']
      }
    };
  },
  created() {
    this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
    this.getHistoryDetail();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'vouchers' });
    },
    getHistoryDetail() {
      if (this.$route.query.from === 'review') {
        consumeAuditInfo({ id: this.$route.query.id }).then(response => {
          this.historyDetail = response.data;
          this.headName = this.statusMap[response.data.auditStatus][0];
          this.color = this.statusMap[response.data.auditStatus][1];
        });
      } else {
        applyCouponInfo({ id: this.$route.query.id }).then(response => {
          this.historyDetail = response.data;
          this.headName = this.statusMap[response.data.auditStatus][0];
          this.color = this.statusMap[response.data.auditStatus][1];
        });
      }
    },
    // 拒绝审核
    refuseCheck() {
      this.showRefuseDialog = true;
    },
    // 提交拒绝审核
    confirmRefuse() {
      const data = {
        id: this.historyDetail.id,
        auditReason: this.message,
        auditStatus: 'AUDIT_REJECT'
      };
      // this.$toast.loading({
      //   message: '上传中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      auditCoupon(data).then(response => {
        this.showRefuseDialog = false;
        if (response.code === 200) {
          this.$toast.success('提交成功');
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    passCheck() {
      const data = {
        id: this.historyDetail.id,
        auditReason: this.message,
        auditStatus: 'AUDIT_PASS'
      };
      // this.$toast.loading({
      //   message: '上传中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      auditCoupon(data).then(response => {
        if (response.code === 200) {
          this.$toast.success('提交成功');
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    showImg(index) {
      const list = [];
      this.historyDetail.attachmentUrls.forEach(item => {
        list.push(this.baseURL + item);
      });
      ImagePreview({ images: list, startPosition: index, closeable: true });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.staffhistoryDetail {
  min-height: 100vh;

  .control {
    .van-field__control{
      text-align: left;
    }
  }

  .van-cell__title {
    -webkit-box-flex: unset;
    -webkit-flex: unset;
    flex: unset;
  }
  padding-bottom: 0.2rem;
  .content {
    padding-bottom: 0.15rem;
    position: relative;
    .inviteWechatShare {
      background-color: #57c55f;
      border-radius: 100%;
      padding: 5px;
    }
    .inviteCopyShare {
      margin-left: 0.02rem;
      background-color: #3b86ff;
      border-radius: 100%;
      padding: 5px;
    }
    .signIn {
      position: absolute;
      top: -10px;
      right: 10px;
      z-index: 19999;
    }
    .content-title,
    .visitStatus {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
    }
    .content-detail,
    .content-reason {
      font-size: 0.17rem;
      color: #333;
      background: #fff;
      padding: 0.18rem 0.15rem;
    }
    .content-detail p:not(:last-child) {
      margin-bottom: 0.1rem;
    }
    .content-reason {
      padding: 0rem 0.15rem;
      .content-reasonItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.55rem;
        line-height: 0.55rem;
        .faceImg {
          width: 0.33rem;
          height: 0.33rem;
          line-height: 0.33rem;
          .svg-icon {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }
      .content-reasonItem:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .has-small-magb{
      position: relative;
      margin-bottom: 0.1rem;
      .content-reasonItem[class~='has-status']{
        height:0.73rem;
      }
      .tip-status{
        width: 0.65rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 14px 0px 0px 14px;
        color: #fff;
        font-size: .14rem;
        position: absolute;
        right: 0px;
        &.CANCEL,
        &.UNVISIT,
        &.AUDIT_FAIL,
        &.OUTTIME_AUDIT {
          background-color: rgba(51, 51, 51, 0.5);
        }

        &.WAITING_AUDIT,
        &.WAITING_VERIFY {
          background-color: #f2b230;
        }

        &.OUTTIME_VISIT,
        &.AUDIT_REJECT {
          background-color: #f76260;
        }

        &.VISITING,
        &.WAITING_VISIT {
          background-color: #3b86ff;
        }

        &.FINISH,
        &.AUDIT_PASSED {
          background-color: #2dcc2c;
        }
      }

    }

    .itemClass {
      background-color: #FFFFFF;
      padding: 0.145rem 0.16rem 0 0.145rem;
      .meetingItem {
        padding-bottom: 0.16rem;
        font-size: 0.16rem;
        color: #333333;
        border-bottom: 1px solid #ebedf0;
      }
    }
    .uploadList {
      display: flex;

      .thumbnail {
        .change_val(width, 80);
        .change_val(height, 80);
      }

      .imgArea {
        display: flex;
        align-items: center;

        img {
          width: 0.35rem;
        }
      }

      .nameArea {
        display: flex;
        flex-direction: column;
        .change_val(margin-left, 8);
        .imgName {
          color: rgba(0, 0, 0, 0.85);
          .change_val(font-size, 28);
          .change_val(line-height, 40);
        }

        .imgSize {
          color: rgba(0, 0, 0, 0.5);
          .change_val(font-size, 24);
          .change_val(line-height, 33);
        }
      }
    }

  }
  .btns {
    display: flex;
    justify-content: space-between;
    //margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: #FFBE00;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
    div:last-child {
      background: #2DCC2C;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
  }
  //.van-field__control {
  //  text-align: left;
  //}
  .shareBtns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      border-radius: 5px;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: rgba(255, 190, 0, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
    div:last-child {
      background: rgba(45, 204, 44, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
  }
  .cover {
    position: absolute;
    opacity: 0.5;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    .share {
      position: absolute;
      right: 20px;
      top: 10px;
      width: 2rem;
      height: 2rem;
    }
    .shareBtn {
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 2rem;
      height: 2rem;
    }
  }

  .van-overlay {
    z-index: 19999;
  }

}
.content-detail:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}
.stall_tip{
  padding: 0 0.15rem;
  font-size: 0.14rem;
  color: #888;
  margin-top: 0.1rem;
}

</style>
